export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const WEBSOCKET_SUB_DIRECTORY = process.env.REACT_APP_WS_SUB_DIRECTORY;
export const SOCKET_URL = `${process.env.REACT_APP_WS_BASE_URL}${WEBSOCKET_SUB_DIRECTORY}`;

export const RECONNECT_INTERVAL_IN_MS = 1000;

export const RECONNECT_MESSAGE = `Socket is closed. Reconnect will be attempted in ${
  RECONNECT_INTERVAL_IN_MS / 1000
} second.`;
